import moment from 'moment';
import { Tag } from 'antd';
import '../../CSS/style.css';
import { connect } from 'react-redux';
import React, { Fragment, useState, useEffect, useCallback, useRef } from 'react';
import { config } from '../../constant';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { ArrowDownOutlined, ArrowUpOutlined, BellFilled } from '@ant-design/icons';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const StatusCounter = (props) => {
  const [counter, setCounter] = useState(0);
  const [uom, setUom] = useState(props.graphprops.uom || '');
  const [statusCounter, setStatusCounter] = useState(0);
  const [status, setStatus] = useState('down');
  const [image, setImage] = useState('');
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);

  let timeTicket = useRef(null);
  let requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);

  const getData = useCallback(async () => {
    requestCheck.current = false;
    let { graphprops } = props;
    let json = [];
    let errorInAPI = false;
    let noDataInDB = false;

    const currentGraphProps = graphprops[graphprops.graph] || {};

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    // json =[
    //   {
    //     "DateTime": "2025-06-13 11:15:40.567154",
    //     "Name": "TagValue",
    //     "Value": 3.78,
    //     "Description": "Component_Replacement(-) , Lubrication_&_Calibration(-) , Routine_Inspections(-)",
    //     "Status": "High",
    //     "StatusValue": "0%/ 0"
    //   }
    // ];

    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      if (json && Array.isArray(json) && json.length > 0) {
        const firstItem = json[0];

        if (currentGraphProps.statusCounterType === 'number') {
          setCounter(Number(firstItem.Value).toFixed(2));
          setStatusCounter(firstItem.StatusValue);
          setStatus(firstItem.Status);
        } else if (currentGraphProps.statusCounterType === 'string') {
          setCounter(firstItem.Value);
          setStatusCounter(firstItem.StatusValue);
          setStatus(firstItem.Status);
        } else if (currentGraphProps.statusCounterType === 'both') {
          setUom(currentGraphProps.uom);
          setStatusCounter(firstItem.StatusValue);
          setStatus(firstItem.Status);
          setCounter(Number(firstItem.Value).toFixed(2));
        } else if (currentGraphProps.statusCounterType === 'notification') {
          setStatusCounter(firstItem.StatusValue);
          setCounter(Number(firstItem.Value).toFixed(2));
        } else if (currentGraphProps.statusCounterType === 'Image & string') {
          setStatus(firstItem.Status);
          setStatusCounter(firstItem.StatusValue);
          setCounter(firstItem.Value);
          setImage(firstItem.Description);
        }
      }

      if (json && Array.isArray(json) && json[0] && json[0].Value === null) {
        setErrorInAPI(errorInAPI);
        setNoDataInDB(!noDataInDB);
      } else {
        setErrorInAPI(errorInAPI);
        setNoDataInDB(noDataInDB);
      }
    }
  }, [props]);

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {moment().format('YYYY-MM-DD HH:mm:ss')}
        </Tag>
      ) : null}
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <div
          className="statusCounter"
          style={{
            textAlign: 'center',
            backgroundColor:
              props.graphprops &&
                props.graphprops[props.graphprops.graph] &&
                props.graphprops[props.graphprops.graph].backgroundColor
                ? props.graphprops[props.graphprops.graph].backgroundColor
                : ''
          }}
        >
          <div
            style={{
              color:
                props.graphprops &&
                  props.graphprops[props.graphprops.graph] &&
                  props.graphprops[props.graphprops.graph].titleColor
                  ? props.graphprops[props.graphprops.graph].titleColor
                  : 'steelblue',
              fontSize:
                props.graphprops &&
                  props.graphprops[props.graphprops.graph] &&
                  props.graphprops[props.graphprops.graph].fontSize
                  ? props.graphprops[props.graphprops.graph].fontSize + 'em'
                  : '5em'
            }}
          >
            {props.graphprops &&
              props.graphprops[props.graphprops.graph] &&
              props.graphprops[props.graphprops.graph].statusCounterType &&
              props.graphprops[props.graphprops.graph].statusCounterType === 'notification' ? (
              <div>
                <BellFilled
                  style={{
                    marginRight: '4px',
                    fontWeight: '800',
                    fontSize: '0.8em',
                    color:
                      props.graphprops &&
                        props.graphprops[props.graphprops.graph] &&
                        props.graphprops[props.graphprops.graph].iconColor &&
                        props.graphprops[props.graphprops.graph].iconColor[0]
                        ? props.graphprops[props.graphprops.graph].iconColor[0]
                        : 'green'
                  }}
                />
                <span
                  style={{
                    color:
                      props.graphprops &&
                        props.graphprops[props.graphprops.graph] &&
                        props.graphprops[props.graphprops.graph].iconColor &&
                        props.graphprops[props.graphprops.graph].iconColor[0]
                        ? props.graphprops[props.graphprops.graph].iconColor[0]
                        : 'green'
                  }}
                >
                  {counter}
                </span>
                <BellFilled
                  style={{
                    marginRight: '4px',
                    fontWeight: '800',
                    fontSize: '0.8em',
                    color:
                      props.graphprops &&
                        props.graphprops[props.graphprops.graph] &&
                        props.graphprops[props.graphprops.graph].iconColor &&
                        props.graphprops[props.graphprops.graph].iconColor[1]
                        ? props.graphprops[props.graphprops.graph].iconColor[1]
                        : 'red'
                  }}
                />
                <span
                  style={{
                    color:
                      props.graphprops &&
                        props.graphprops[props.graphprops.graph] &&
                        props.graphprops[props.graphprops.graph].iconColor &&
                        props.graphprops[props.graphprops.graph].iconColor[1]
                        ? props.graphprops[props.graphprops.graph].iconColor[1]
                        : 'red'
                  }}
                >
                  {statusCounter}
                  {uom}
                </span>
              </div>
            ) : props.graphprops &&
              props.graphprops[props.graphprops.graph] &&
              props.graphprops[props.graphprops.graph].statusCounterType &&
              props.graphprops[props.graphprops.graph].statusCounterType === 'Image & string' ? (
              <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div>
                  {counter}
                  {uom}
                </div>

                <span
                  style={{
                    justifyContent: 'center',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <img
                    src={image ? image : ''}
                    type="image"
                    alt=""
                    style={{ height: '100px', width: '110px', marginTop: '7px' }}
                  />
                </span>
              </div>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div>
                  {counter}
                  {uom}
                </div>
              </div>
            )}
          </div>

          {props.graphprops.graph === 'statusCounter' && status === 'High' ? (
            <div
              style={{
                color:
                  props.graphprops[props.graphprops.graph] &&
                    props.graphprops[props.graphprops.graph].iconColor &&
                    props.graphprops[props.graphprops.graph].iconColor[0]
                    ? props.graphprops[props.graphprops.graph].iconColor[0]
                    : '#389e0d',
                marginRight: '2%',
                fontSize: '1.5em',
                textAlign: 'center',
                fontWeight: '600'
              }}
            >
              <ArrowUpOutlined
                style={{
                  marginRight: '4px',
                  fontWeight: '800',
                  fontSize: '0.8em'
                }}
              />
              {statusCounter} {uom}
            </div>
          ) : props.graphprops.graph === 'statusCounter' && status === 'Low' ? (
            <div
              style={{
                color:
                  props.graphprops &&
                    props.graphprops[props.graphprops.graph] &&
                    props.graphprops[props.graphprops.graph].iconColor &&
                    props.graphprops[props.graphprops.graph].iconColor[0]
                    ? props.graphprops[props.graphprops.graph].iconColor[0]
                    : 'white',
                marginRight: '2%',
                fontSize: '1.5em',
                textAlign: 'center',
                fontWeight: '600'
              }}
            >
              <ArrowDownOutlined
                style={{
                  marginRight: '4px',
                  fontWeight: '800',
                  fontSize: '0.8em'
                }}
              />
              {statusCounter}
              {uom}
            </div>
          ) : props.graphprops.graph === 'statusCounter' && status === 'Equal' ? (
            <div
              style={{
                color:
                  props.graphprops &&
                    props.graphprops[props.graphprops.graph] &&
                    props.graphprops[props.graphprops.graph].iconColor &&
                    props.graphprops[props.graphprops.graph].iconColor[0]
                    ? props.graphprops[props.graphprops.graph].iconColor[0]
                    : 'white',
                marginRight: '2%',
                fontSize: '1.5em',
                textAlign: 'center',
                fontWeight: '600'
              }}
            >
              {statusCounter}
              {uom}
            </div>
          ) : null}
        </div>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};
export default connect(mapStateToProps)(StatusCounter);